import React from 'react'
import {Box, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const GiftCertificateImage = () => {
    return (
        <Box p={5} maxW="600px" mx="auto">
            <Image src={getAssetUrl('static/img/gift-card.png')} alt="Gift Certificates" />
        </Box>
    )
}

export default GiftCertificateImage
